import { render, staticRenderFns } from "./LetterIndex.vue?vue&type=template&id=3639b0fe&"
import script from "./LetterIndex.vue?vue&type=script&lang=js&"
export * from "./LetterIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports